import React from 'react'
import Services from '../home/Services'

const ServicesPage = () => {
  return (
    <section className='p-about-us'>
      <div className='p-services-header'>
        <div>
          <h1>Services</h1>
        </div>
      </div>
      <Services />
    </section>
  )
}

export default ServicesPage